import { useState, useEffect, useContext } from 'react';
import { Table, Tag, Button, Space, message } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext';

export default function OverallOT() {
    const { authData, backUrl } = useContext(AuthContext);
    const [otData, setOtData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${backUrl}/api/hr/attendance-requests/`, {
                headers: {
                    Authorization: `Bearer ${authData?.access}`
                }
            });
            setOtData(res.data.results);
        } catch (error) {
            message.error('Failed to fetch attendance requests');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleApprove = async (record) => {
        try {
            await axios.patch(
                `${backUrl}/api/hr/attendance-approvals/${record.id}/`,
                {
                    "attendance_id": 47315,
                    "employee": 47,
                    "reason": "Regularizing from backend.",
                    "remarks": "Auto-approved by HR."
                },
                {
                    headers: {
                        Authorization: `Bearer ${authData?.access}`
                    }
                }
            );
            message.success('Request approved successfully');
            fetchData();
        } catch (error) {
            message.error('Failed to approve request');
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const columns = [
        {
            title: 'Employee Name',
            dataIndex: 'employee_name',
            key: 'employee_name',
            width: 150,
        },
        {
            title: 'Attendance Date',
            dataIndex: 'attendance_date',
            key: 'attendance_date',
            width: 130,
            render: (date) => new Date(date).toLocaleDateString(),
        },
        {
            title: 'Status Message',
            dataIndex: 'original_status_message',
            key: 'original_status_message',
            width: 200,
        },
        {
            title: 'Permission Hours',
            dataIndex: 'permission_hours_deducted',
            key: 'permission_hours_deducted',
            width: 130,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 110,
            render: (status) => (
                <Tag color={status === 'Approved' ? 'green' : status === 'Pending' ? 'orange' : 'red'}>
                    {status}
                </Tag>
            ),
        },
        {
            title: 'Remarks',
            dataIndex: 'remarks',
            key: 'remarks',
            width: 150,
            render: (remarks) => remarks || '-',
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 160,
            render: (date) => new Date(date).toLocaleString(),
        },
        {
            title: 'Action',
            key: 'action',
            width: 100,
            render: (_, record) => (
                <Space>
                    {record.status !== 'Approved' ? (
                        <Button
                            type="primary"
                            icon={<CheckOutlined />}
                            size="small"
                            onClick={() => handleApprove(record)}
                            style={{ background: 'green', color: 'white' }}
                        >
                            Approve
                        </Button>
                    ) : (
                        <Tag color="green">Approved</Tag>
                    )}
                </Space>
            ),
        },
    ];

    return (
        <div style={{ padding: '24px' }}>
            {/* <h2 style={{ marginBottom: '16px' }}>Attendance Requests</h2> */}
            <Table
                columns={columns}
                dataSource={otData}
                rowKey="id"
                loading={loading}
                scroll={{ x: 'max-content' }}
                pagination={{
                    pageSize: 10,
                    showSizeChanger: true,
                    showTotal: (total) => `Total ${total} items`,
                }}
                components={{
                    header: {
                        cell: (props) => (
                            <th {...props} style={{ backgroundColor: "#0e497b", color: 'white', marginTop: '20px' }}>
                                {props.children}
                            </th>
                        ),
                    },
                }}
                bordered
            />
        </div>
    );
}